package br.com.texeratx.boardgametimeapp.ui.screens.players.edit

data class EditPlayerState(
    val name: String = "",
    val nickname: String = "",

    // URL final (Cloudinary) usada no update
    val imageUrl: String = "",

    // Preview local
    val localImageBytes: ByteArray? = null,
    val localImageMimeType: String? = null,
    val selectedImageName: String? = null,

    val isUploadingImage: Boolean = false,

    val birthday: String = "",
    val phone: String = "",

    val isSaving: Boolean = false,
    val error: String? = null
)